module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp23_9005.85f8c2b0.png";